// extracted by mini-css-extract-plugin
export var inlineLink = "_aj-0";
export var inlineLinkButton = "_aj-1";